/**
 * Parse tanggal dari API (format "YYYY-MM-DD" atau Date object)
 * tanpa konversi timezone — selalu baca sebagai tanggal lokal.
 * 
 * Root cause: new Date("2026-04-25") diparsing sebagai UTC midnight,
 * sehingga di timezone WIB (+07:00) menjadi 2026-04-24T17:00 hari sebelumnya.
 * Solusi: tambahkan T00:00:00 agar diparsing sebagai local time, 
 * atau gunakan string split langsung tanpa new Date().
 */

/**
 * Ambil string "YYYY-MM-DD" dari nilai tanggal apapun yang datang dari API.
 * Handles: string "2026-04-25", string "2026-04-25T00:00:00.000Z", Date object.
 */
export function toDateStr(val) {
  if (!val) return '';
  // Kalau sudah string, ambil 10 karakter pertama (YYYY-MM-DD)
  if (typeof val === 'string') return val.slice(0, 10);
  // Kalau Date object, format manual pakai local time (bukan UTC)
  if (val instanceof Date) {
    const y = val.getFullYear();
    const m = String(val.getMonth() + 1).padStart(2, '0');
    const d = String(val.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  return String(val).slice(0, 10);
}

/**
 * Format tanggal ke display Indonesia: "25 April 2026"
 * Gunakan ini SELALU, jangan new Date(tanggalString) langsung.
 */
export function formatTanggalID(val, opts = {}) {
  const str = toDateStr(val);
  if (!str) return '-';
  // Parse sebagai local time dengan menambah T00:00:00
  const d = new Date(str + 'T00:00:00');
  return d.toLocaleDateString('id-ID', {
    day: 'numeric', month: 'long', year: 'numeric', ...opts
  });
}

/**
 * Format tanggal singkat: { day: "25", month: "APR" }
 */
export function formatDateBadge(val) {
  const str = toDateStr(val);
  if (!str) return { day: '--', month: '---' };
  const d = new Date(str + 'T00:00:00');
  return {
    day: d.getDate(),
    month: d.toLocaleString('id-ID', { month: 'short' }).toUpperCase(),
  };
}

/**
 * Dapatkan "YYYY-MM-DD" dari Date object lokal (untuk hari ini, dll)
 */
export function todayStr() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Konversi Date object ke "YYYY-MM-DD" menggunakan local time
 */
export function dateToStr(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
